import React from 'react';
import {Col, Form, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {useField} from 'formik';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export default function Select({label, options, value, ...props}) {
    const [field, meta] = useField(props);
    const inputId = props.id || `input_${props.name}`;
    const inputValue = value !== undefined ? value : (field.value !== undefined && field.value !== null ? field.value : '');
    let inputClass = meta.touched && meta.error ? 'input error' : 'input';
    if (props.cssclass) inputClass += ' ' + props.cssclass;
    const groupProperties = {size: 'lg'};
    if (props.skipgroup === undefined) groupProperties.as = Col;
    return (
        <Form.Group {...groupProperties}>
            <Form.Label htmlFor={inputId}>{label}</Form.Label>
            {props.info
                ?
                <OverlayTrigger placement="top" overlay={<Tooltip>{props.info}</Tooltip>}>
                    <FontAwesomeIcon icon="fa-circle-info" size="1x" style={{marginLeft: '5px'}} />
                </OverlayTrigger>
                : null}
            <Form.Control as="select" {...field} {...props} id={inputId} value={inputValue} className={inputClass}>
                {options.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
            </Form.Control>
            {meta.touched && meta.error && <Form.Text className="text-muted text-danger">{meta.error}</Form.Text>}
        </Form.Group>
    );
}
